/* bb-offers.js — dynamic pairing offers for Building Blox.
   No apps, no new sections. Data comes from snippets/bb-offers-data.liquid. */
(function () {
  "use strict";

  var DATA = [];
  try {
    var el = document.getElementById("bb-offers-data");
    if (el) DATA = JSON.parse(el.textContent || "[]");
  } catch (e) {
    console.warn("[bb-offers] bad data", e);
  }
  if (!DATA.length) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var CFG = window.BBOffers || {};
  var STR = {
    bundleTitle: "Frequently bought together",
    popupTitle: "Complete your stack",
    cartTitle: "Add one more and save",
    addBoth: "Add both and save",
    add: "Add",
    choose: "Choose option",
    noThanks: "No thanks",
    inCart: "In your cart",
    save: "Save",
    alsoTitle: "Customers also add",
    alsoOffer: "Another offer on this product",
  };
  Object.keys(CFG.strings || {}).forEach(function (k) {
    if (CFG.strings[k]) STR[k] = CFG.strings[k];
  });

  /* ---------- helpers ---------- */
  function pairsFor(productId) {
    return DATA.filter(function (p) {
      return p.items.some(function (i) { return i.id === productId; });
    });
  }
  function partnerOf(pair, productId) {
    return pair.items.filter(function (i) { return i.id !== productId; })[0];
  }
  function getCart() {
    return fetch(root + "cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }
  function cartProductIds(cart) {
    return (cart.items || []).map(function (i) { return i.product_id; });
  }
  function addVariant(variantId, qty) {
    return fetch(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] }),
    }).then(function (r) { return r.json(); });
  }
  function refreshCart() {
    var drawer = document.querySelector("m-cart-drawer");
    if (drawer && typeof drawer.onCartDrawerUpdate === "function") {
      drawer.onCartDrawerUpdate();
      if (typeof drawer.open === "function") drawer.open();
      return;
    }
    if (document.body.classList.contains("template-cart")) window.location.reload();
  }
  function img(src, size) {
    if (!src) return "";
    return src.replace(/(\.(jpg|jpeg|png|webp|gif))/i, "_" + (size || 160) + "x$1");
  }
  function money(cents) {
    var fmt = CFG.moneyFormat || "{{amount}}";
    var n = (cents / 100).toFixed(2);
    var parts = n.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, parts.join("."));
  }

  function recsFor(productId, limit, intent) {
    return fetch(root + "recommendations/products.json?product_id=" + productId + "&limit=" + limit + "&intent=" + intent, {
      headers: { Accept: "application/json" },
    })
      .then(function (r) { return r.json(); })
      .then(function (j) { return (j && j.products) || []; })
      .catch(function () { return []; });
  }

  function recsMerged(productId, want) {
    return recsFor(productId, want, "complementary").then(function (a) {
      if (a.length >= want) return a;
      return recsFor(productId, want + a.length, "related").then(function (b) {
        var seen = a.map(function (p) { return p.id; });
        b.forEach(function (p) {
          if (a.length >= want) return;
          if (seen.indexOf(p.id) !== -1) return;
          seen.push(p.id);
          a.push(p);
        });
        return a;
      });
    });
  }

  function railCard(it) {
    var save = it.saveText
      ? '<span class="bb-rail__save">' + esc(it.saveText) + "</span>"
      : "";
    return (
      '<li class="bb-rail__item">' +
      '<a class="bb-rail__media" href="' + esc(it.url) + '">' +
      '<img src="' + esc(img(it.image, 240)) + '" alt="' + esc(it.title) + '" loading="lazy" width="96" height="96">' +
      save +
      "</a>" +
      '<a class="bb-rail__name" href="' + esc(it.url) + '">' + esc(it.title) + "</a>" +
      '<span class="bb-rail__price">' + esc(it.priceText) + "</span>" +
      '<button type="button" class="bb-rail__btn" data-bb-add-variant="' + it.variantId + '">' + esc(STR.add) + "</button>" +
      "</li>"
    );
  }

  function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : s; return d.innerHTML; }

  /* ---------- card markup ---------- */
  function itemCell(it) {
    return (
      '<a class="bb-of__cell" href="' + esc(it.url) + '">' +
      '<img class="bb-of__img" src="' + esc(img(it.image, 160)) + '" alt="' + esc(it.title) + '" width="60" height="60" loading="lazy">' +
      '<span class="bb-of__cellText"><span class="bb-of__name">' + esc(it.title) + "</span>" +
      '<span class="bb-of__price">' + it.price_f + "</span></span></a>"
    );
  }

  function pairCard(pair, opts) {
    opts = opts || {};
    var needsChoice = pair.items.some(function (i) { return i.variants > 1; });
    var btnLabel = opts.addLabel || STR.addBoth + " " + pair.save_f;
    return (
      '<div class="bb-of" data-bb-pair="' + esc(pair.key) + '">' +
      '<div class="bb-of__head"><span class="bb-of__title">' + esc(opts.title || STR.bundleTitle) + "</span>" +
      '<span class="bb-of__badge">-' + pair.pct + "%</span></div>" +
      '<div class="bb-of__grid">' + itemCell(pair.items[0]) + '<span class="bb-of__plus">+</span>' + itemCell(pair.items[1]) + "</div>" +
      '<div class="bb-of__foot">' +
      '<div class="bb-of__sum"><span class="bb-of__was">' + pair.combined_f + "</span>" +
      '<span class="bb-of__now">' + pair.offer_f + "</span>" +
      '<span class="bb-of__save">' + STR.save + " " + pair.save_f + "</span></div>" +
      '<button type="button" class="bb-of__btn" data-bb-add-pair="' + esc(pair.key) + '">' + esc(btnLabel) + "</button>" +
      "</div>" +
      (needsChoice ? '<p class="bb-of__note">' + STR.choose + " on the product page for flavour choices.</p>" : "") +
      "</div>"
    );
  }

  function singleCard(pair, partner, opts) {
    opts = opts || {};
    return (
      '<div class="bb-of bb-of--single" data-bb-pair="' + esc(pair.key) + '">' +
      '<div class="bb-of__head"><span class="bb-of__title">' + esc(opts.title || STR.cartTitle) + "</span>" +
      '<span class="bb-of__badge">-' + pair.pct + "%</span></div>" +
      '<div class="bb-of__grid bb-of__grid--one">' + itemCell(partner) + "</div>" +
      '<div class="bb-of__foot">' +
      '<div class="bb-of__sum"><span class="bb-of__save">' + STR.save + " " + pair.save_f + " on the pair</span></div>" +
      '<button type="button" class="bb-of__btn" data-bb-add-variant="' + partner.variant_id + '">' + esc(STR.add) + " " + partner.price_f + "</button>" +
      "</div></div>"
    );
  }

  /* ---------- click handling ---------- */
  document.addEventListener("click", function (e) {
    var addPair = e.target.closest("[data-bb-add-pair]");
    var addOne = e.target.closest("[data-bb-add-variant]");
    var closeBtn = e.target.closest("[data-bb-close]");

    if (closeBtn) { closeModal(); return; }

    if (addPair) {
      e.preventDefault();
      var key = addPair.getAttribute("data-bb-add-pair");
      var pair = DATA.filter(function (p) { return p.key === key; })[0];
      if (!pair) return;
      addPair.disabled = true;
      selfAdd = true;
      getCart().then(function (cart) {
        var have = cartProductIds(cart);
        var toAdd = pair.items.filter(function (i) { return have.indexOf(i.id) === -1; });
        if (!toAdd.length) { addPair.disabled = false; return; }
        return fetch(root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: toAdd.map(function (i) { return { id: i.variant_id, quantity: 1 }; }) }),
        }).then(function (r) { return r.json(); });
      }).then(function () {
        addPair.disabled = false;
        setTimeout(function () { selfAdd = false; }, 800);
        closeModal();
        refreshCart();
      }).catch(function () { addPair.disabled = false; selfAdd = false; });
      return;
    }

    var addMany = e.target.closest("[data-bb-add-variants]");
    if (addMany) {
      e.preventDefault();
      var list = (addMany.getAttribute("data-bb-add-variants") || "")
        .split(",").map(function (x) { return parseInt(x, 10); }).filter(Boolean);
      if (!list.length) return;
      addMany.disabled = true;
      selfAdd = true;
      getCart().then(function (cart) {
        var haveV = (cart.items || []).map(function (i) { return i.variant_id; });
        var todo = list.filter(function (v) { return haveV.indexOf(v) === -1; });
        if (!todo.length) return;
        return fetch(root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: todo.map(function (v) { return { id: v, quantity: 1 }; }) }),
        }).then(function (r) { return r.json(); });
      }).then(function () {
        addMany.disabled = false;
        setTimeout(function () { selfAdd = false; }, 800);
        closeModal();
        refreshCart();
      }).catch(function () { addMany.disabled = false; selfAdd = false; });
      return;
    }

    if (addOne) {
      e.preventDefault();
      var vid = parseInt(addOne.getAttribute("data-bb-add-variant"), 10);
      addOne.disabled = true;
      selfAdd = true;
      addVariant(vid, 1).then(function () {
        addOne.disabled = false;
        setTimeout(function () { selfAdd = false; }, 800);
        closeModal();
        refreshCart();
      }).catch(function () { addOne.disabled = false; selfAdd = false; });
    }
  });

  /* ---------- 1. product page ---------- */
  function placeSectionSlot() {
    var slot = document.querySelector('.bb-of__slot--section[data-bb-placement="buybox"]');
    if (!slot || slot.dataset.bbPlaced === "1") return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var anchor = form.querySelector('[type="submit"], .m-product-form__submit, button[name="add"]');
    if (!anchor || !anchor.parentNode) return;
    anchor.parentNode.insertBefore(slot, anchor);
    slot.dataset.bbPlaced = "1";
  }

  function mountProductPage() {
    placeSectionSlot();
    var pid = CFG.productId;
    if (!pid) return;
    // The "Pairing offer" section already renders this server-side. Do not duplicate it.
    if (document.querySelector(".bb-of__slot--section")) return;
    var pairs = pairsFor(pid);
    if (!pairs.length) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    if (form.querySelector(".bb-of")) return;
    var wrap = document.createElement("div");
    wrap.className = "bb-of__slot bb-of__slot--pdp";
    wrap.innerHTML = pairs.map(function (p) { return pairCard(p); }).join("");
    var anchor = form.querySelector('[type="submit"], .m-product-form__submit, button[name="add"]');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wrap, anchor);
    else form.appendChild(wrap);
  }

  /* ---------- 2. add-to-cart popup ---------- */
  var modal;
  function closeModal() {
    if (modal) { modal.classList.remove("bb-of__modal--open"); setTimeout(function () { if (modal) modal.remove(); modal = null; }, 200); }
  }
  function openModal(html) {
    closeModal();
    modal = document.createElement("div");
    modal.className = "bb-of__modal";
    modal.innerHTML =
      '<div class="bb-of__backdrop" data-bb-close></div>' +
      '<div class="bb-of__dialog" role="dialog" aria-modal="true" aria-label="' + esc(STR.popupTitle) + '">' +
      '<button class="bb-of__x" type="button" data-bb-close aria-label="Close">&times;</button>' +
      html +
      '<button class="bb-of__skip" type="button" data-bb-close>' + esc(STR.noThanks) + "</button>" +
      "</div>";
    document.body.appendChild(modal);
    requestAnimationFrame(function () { modal.classList.add("bb-of__modal--open"); });
  }

  var selfAdd = false;      // true while WE are adding, so we do not pop up over ourselves
  var lastPop = 0;

  function addedIdsFrom(res) {
    if (!res || typeof res !== "object") return [];
    if (Array.isArray(res.items)) {
      return res.items.map(function (i) { return i && i.product_id; }).filter(Boolean);
    }
    return res.product_id ? [res.product_id] : [];
  }

  function handleAdd(res) {
    if (CFG.showPopup === false) return;
    if (selfAdd) return;
    var now = Date.now();
    if (now - lastPop < 1500) return;      // one popup per add, whoever fired it
    var ids = addedIdsFrom(res);
    if (!ids.length) return;
    lastPop = now;
    getCart().then(function (cart) {
      var have = cartProductIds(cart);
      var anchor = ids[0];
      var card = "", skip = have.slice(), firstTitle = true;

      for (var n = 0; n < ids.length; n++) {
        var pairs = pairsFor(ids[n]);
        if (!pairs.length) continue;
        if (anchor === ids[0]) anchor = ids[n];

        // Then every individual offer it belongs to.
        for (var i = 0; i < pairs.length; i++) {
          var partner = partnerOf(pairs[i], ids[n]);
          if (!partner || !partner.available) continue;
          if (have.indexOf(partner.id) !== -1) continue;
          if (skip.indexOf(partner.id) !== -1) continue;
          card += singleCard(pairs[i], partner, { title: firstTitle ? STR.popupTitle : STR.alsoOffer });
          firstTitle = false;
          skip.push(partner.id);
        }
      }

      // Cross-sell rail under the offer, so the popup always has something to sell.
      return recsMerged(anchor, 10)
        .then(function (ps) {
          var items = [];
          ps.forEach(function (p) {
            if (items.length >= 4) return;
            if (skip.indexOf(p.id) !== -1 || !p.available) return;
            var v = (p.variants || []).filter(function (x) { return x.available; })[0];
            if (!v) return;
            skip.push(p.id);
            items.push({
              id: p.id, title: p.title, url: p.url,
              image: p.featured_image || (p.images && p.images[0]),
              priceText: money(p.price), variantId: v.id, saveText: "",
            });
          });
          var rail = items.length
            ? '<div class="bb-rail bb-rail--pop">' +
              '<div class="bb-rail__head"><span class="bb-rail__title">' + esc(STR.alsoTitle) + "</span></div>" +
              '<ul class="bb-rail__list">' + items.map(railCard).join("") + "</ul></div>"
            : "";
          if (!card && !rail) return;
          openModal(card + rail);
        });
    }).catch(function () {});
  }

  // The theme fires this, but a cart app may replace the theme's add handler entirely,
  // so we also watch the network for any add to cart, whoever makes it.
  document.addEventListener("product-ajax:added", function (e) {
    handleAdd((e.detail && e.detail.product) || {});
  });

  function isAddUrl(u) { return typeof u === "string" && u.indexOf("/cart/add") !== -1; }

  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var p = _fetch.apply(this, arguments);
      if (isAddUrl(url)) {
        p.then(function (res) {
          try {
            res.clone().json().then(function (j) { setTimeout(function () { handleAdd(j); }, 350); }).catch(function () {});
          } catch (e) {}
          return res;
        }).catch(function () {});
      }
      return p;
    };
  }

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) { this.__bbUrl = u; return _open.apply(this, arguments); };
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    if (isAddUrl(self.__bbUrl)) {
      self.addEventListener("load", function () {
        try { var j = JSON.parse(self.responseText); setTimeout(function () { handleAdd(j); }, 350); } catch (e) {}
      });
    }
    return _send.apply(this, arguments);
  };

  /* ---------- 3. cart cross-sell ---------- */
  function buildCandidates(cart) {
    var have = cartProductIds(cart);
    var seen = have.slice();
    var out = [];

    // 1. Pairing partners first, richest saving first — these carry a real offer.
    var fromPairs = [];
    have.forEach(function (pid) {
      pairsFor(pid).forEach(function (pair) {
        var partner = partnerOf(pair, pid);
        if (!partner || !partner.available) return;
        if (seen.indexOf(partner.id) !== -1) return;
        if (fromPairs.some(function (x) { return x.id === partner.id; })) return;
        fromPairs.push({
          id: partner.id,
          title: partner.title,
          url: partner.url,
          image: partner.image,
          priceText: partner.price_f,
          variantId: partner.variant_id,
          saveText: STR.save + " " + pair.save_f,
          sortKey: pair.save,
          pair: pair,
        });
      });
    });
    fromPairs.sort(function (a, b) { return b.sortKey - a.sortKey; });
    fromPairs.forEach(function (x) { out.push(x); seen.push(x.id); });

    // 2. Then Shopify's own recommendations for the biggest item in the cart.
    var anchor = null, best = -1;
    (cart.items || []).forEach(function (i) {
      if (i.line_price > best) { best = i.line_price; anchor = i.product_id; }
    });
    if (!anchor) return Promise.resolve(out);

    return recsMerged(anchor, 10)
      .then(function (ps) {
        ps.forEach(function (p) {
          if (out.length >= 8) return;
          if (seen.indexOf(p.id) !== -1) return;
          if (!p.available) return;
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (!v) return;
          seen.push(p.id);
          out.push({
            id: p.id,
            title: p.title,
            url: p.url,
            image: p.featured_image || (p.images && p.images[0]),
            priceText: money(p.price),
            variantId: v.id,
            saveText: "",
          });
        });
        return out;
      });
  }

  function cartHosts() {
    var SEL = [
      "m-cart-drawer [data-minimog-cart-items]",
      ".m-cart__items",
      "[data-cart-items]",
      ".cart-drawer__items",
      ".cart__items",
    ];
    var hosts = [];
    SEL.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (n) {
        if (n.offsetParent !== null || n.getClientRects().length) hosts.push(n);
      });
    });
    if (!hosts.length) {
      document.querySelectorAll(SEL.join(",")).forEach(function (n) { hosts.push(n); });
    }
    return hosts;
  }

  function mountCart() {
    if (CFG.showCart === false) return;
    getCart().then(function (cart) {
      var have = cartProductIds(cart);
      if (!have.length) {
        Array.prototype.forEach.call(document.querySelectorAll(".bb-of__slot--cart"), function (n) { n.remove(); });
        return;
      }
      return buildCandidates(cart).then(function (items) {
        var hosts = cartHosts();
        var sig = have.join(",") + "|" + items.map(function (i) { return i.id; }).join(",") + "|" + hosts.length +
          "|" + (document.querySelector(".bb-up__block") ? "u" : "r");
        var existing = document.querySelectorAll(".bb-of__slot--cart");
        if (existing.length && existing.length === hosts.length && existing[0].getAttribute("data-bb-sig") === sig) return;
        Array.prototype.forEach.call(existing, function (n) { n.remove(); });
        if (!items.length || !hosts.length) return;

        // If the server-rendered upsell block is present it already carries a broad rail,
        // so we contribute only the pairing offer and put it ABOVE, where strategy belongs.
        var upsellBlock = document.querySelector(".bb-up__block");
        var html;
        if (upsellBlock) {
          var offer = items.filter(function (i) { return i.pair; })[0];
          if (!offer) return;
          html = singleCard(offer.pair, offer, { title: STR.cartTitle });
        } else {
          html =
            '<div class="bb-rail">' +
            '<div class="bb-rail__head"><span class="bb-rail__title">' + esc(STR.cartTitle) + "</span></div>" +
            '<ul class="bb-rail__list">' + items.map(railCard).join("") + "</ul>" +
            "</div>";
        }

        hosts.forEach(function (host) {
          var wrap = document.createElement("div");
          wrap.className = "bb-of__slot bb-of__slot--cart";
          wrap.setAttribute("data-bb-sig", sig);
          wrap.innerHTML = html;
          var block = host.querySelector(".bb-up__block");
          if (block) host.insertBefore(wrap, block);
          else host.appendChild(wrap);
        });
      });
    }).catch(function () {});
  }

  function boot() { mountProductPage(); mountCart(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("cart:updated", mountCart);

  // A cart app can open its own drawer without firing any theme event.
  // Watch for one appearing and mount into it.
  var moTimer = null;
  try {
    new MutationObserver(function () {
      clearTimeout(moTimer);
      moTimer = setTimeout(mountCart, 400);
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
  document.addEventListener("product-ajax:added", function () { setTimeout(mountCart, 600); });
  document.addEventListener("shopify:section:load", function () { setTimeout(boot, 50); });
})();
